<template>
  <div class="reserve">
    <div class="reserve-export">
      <el-button
        type="primary"
        size="small"
        round
        @click="exportExcel"
      >导出</el-button>
    </div>
    <div class="reserve-form">
      <van-form @submit="search">
        <van-field
          readonly
          clickable
          name="datetimePicker"
          :value="searchForm.dateString"
          right-icon="arrow"
          label="预约日期"
          placeholder="点击选择预约日期"
          @click="dateShow = true"
        />
        <van-popup
          v-model="dateShow"
          position="bottom"
        >
          <van-calendar
            v-model="dateShow"
            :max-range="30"
            :default-date="searchForm.date"
            :allow-same-day="true"
            :min-date="new Date('2023/3/1')"
            @confirm="onDateConfirm"
            type="range"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="searchForm.room_name"
          label="会议室"
          right-icon="arrow"
          placeholder="点击会议室"
          @click="showMeetingRoom = true"
        />
        <van-popup
          v-model="showMeetingRoom"
          position="bottom"
        >
          <van-picker
            show-toolbar
            value-key="label"
            :columns="meetingRoomList"
            @confirm="onMeetingRoomConfirm"
            @cancel="showMeetingRoom = false"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="searchForm.booker_name"
          label="预约人"
          right-icon="arrow"
          placeholder="点击选择预约人"
          @click="showUserPicker = true"
        />
        <van-popup
          v-model="showUserPicker"
          position="bottom"
        >
          <van-picker
            show-toolbar
            value-key="label"
            :columns="userList"
            @confirm="onUserConfirm"
            @cancel="showUserPicker = false"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="searchForm.dept_name"
          label="部门"
          right-icon="arrow"
          placeholder="点击选择部门"
          @click="showDeptPicker = true"
        />
        <van-popup
          v-model="showDeptPicker"
          position="bottom"
        >
          <van-picker
            show-toolbar
            value-key="label"
            :columns="deptList"
            @confirm="onDeptfirm"
            @cancel="showDeptPicker = false"
          />
        </van-popup>
        <div style="margin: 16px;">
          <el-button
            type="primary"
            size="small"
            round
            @click="search"
            :loading="loading"
          >搜索</el-button>
        </div>

      </van-form>
      <div
        class="reserve-title"
        v-html="title"
      >
      </div>
    </div>

    <div class="reserve-table">
      <el-table
        :data="tableData"
        height="100%"
        border
        style="width: 100%"
        size="small"
        row-key="appointmentNo"
      >
        <el-table-column
          prop="user_name"
          label="预约人"
          width="60px"
        >
        </el-table-column>
        <el-table-column
          prop="room_name"
          label="会议室"
          width="100px"
        >
        </el-table-column>
        <el-table-column
          prop="dept_name"
          label="所属部门"
          width="100px"
        >
        </el-table-column>

        <el-table-column
          prop="booking_date"
          label="预约日期"
        >
        </el-table-column>
        <el-table-column
          prop="booking_title"
          label="沙龙主题"
        >
        </el-table-column>
        <el-table-column
          prop="channel_name"
          label="渠道"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
// import getUserInfo from "@/models/userInfo";
import { Message } from "element-ui";
import salonMixins from "./mixins/index.js";
import meetingService from "@/apis/meeting/index.js";
import * as dd from "dingtalk-jsapi";
import { Toast } from "vant";

export default {
  mixins: [salonMixins],

  data() {
    return {
      isMobile: /Android|webOS|iPhone|iPod|BlackBerry/i.test(
        navigator.userAgent
      ),
      activeNames: [],
      title: "",
      dateShow: false,

      showMeetingRoom: false,
      meetingRoomList: [],

      showDeptPicker: false,
      deptList: [],

      showUserPicker: false,
      userList: [],

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() + 86400000 < Date.now();
        },
      },
      searchForm: {
        date: [
          new Date(moment().format("YYYY-MM-DD")),
          new Date(moment().format("YYYY-MM-DD")),
        ],

        room_id: "",
        room_name: "全部",
        dept_id: "",
        dept_name: "全部",
        booker_id: "",
        booker_name: "全部",
      },
      tableData: [],

      loading: false,
    };
  },
  watch: {
    searchForm: {
      handler(newVal) {
        this.searchForm.dateString = `${moment(newVal.date[0]).format(
          "YYYY-MM-DD"
        )}至${moment(newVal.date[1]).format("YYYY-MM-DD")}`;
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    // const userInfo = await getUserInfo();

    this.currentUserInfo = {};
    this.getTableList();
    this.getMeetingStatisticOption();
  },
  methods: {
    exportExcel() {
      if (dd.env.platform !== "notInDingTalk") {
        Toast("请在系统自带浏览器中打开页面导出EXCEL");
        return;
      }
      const params = {
        export_list: this.tableData,
      };
      meetingService.exportExcel(params).then((res) => {
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "salon.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      });
    },
    getMeetingStatisticOption() {
      // const { currentUserInfo } = this;
      const params = {
        // ding_user_id: currentUserInfo.ding_user_id,
        ding_user_id: "123",
      };
      meetingService.getMeetingStatisticOption(params).then((res) => {
        const allOpton = {
          label: "全部",
          value: "",
        };

        res.depts.forEach((item) => {
          item.label = item.dept_name;
          item.value = item.dept_id;
        });
        res.depts.unshift(allOpton);
        this.deptList = res.depts;

        res.users.forEach((item) => {
          item.label = item.user_name;
          item.value = item.user_id;
        });
        res.users.unshift(allOpton);
        this.userList = res.users;

        res.rooms.forEach((item) => {
          item.label = item.room_name;
          item.value = item.room_id;
        });
        res.rooms.unshift(allOpton);
        this.meetingRoomList = res.rooms;

        console.log(res);
      });
    },
    onDateConfirm(date) {
      this.searchForm.date = date;
      this.dateShow = false;
    },

    onMeetingRoomConfirm(item) {
      const { searchForm } = this;
      searchForm.room_name = item.label;
      searchForm.room_id = item.value;
      this.showMeetingRoom = false;
    },
    onUserConfirm(item) {
      const { searchForm } = this;
      searchForm.booker_id = item.value;
      searchForm.booker_name = item.label;
      this.showUserPicker = false;
    },
    onDeptfirm(item) {
      const { searchForm } = this;
      searchForm.dept_id = item.value;
      searchForm.dept_name = item.label;
      this.showDeptPicker = false;
    },
    search() {
      const { searchForm } = this;
      const date = searchForm.date;
      if (moment(date[1]).isAfter(moment(date[0]).add(1, "months"))) {
        Message({
          message: "最多查询时间范围为一个月",
          type: "warning",
        });
        return;
      }
      this.getTableList();
    },
    getTableList() {
      const { searchForm } = this;
      const params = {
        // date_start: moment(searchForm.date[0]).format("YYYY-MM-DD"),
        date_start: moment(searchForm.date[0]).format("YYYY-MM-DD"),
        date_end: moment(searchForm.date[1]).format("YYYY-MM-DD"),
        ...searchForm,
      };
      this.loading = true;
      meetingService
        .getMeetingStatisticData(params)
        .then((res) => {
          this.tableData = res.list;
          this.title = `
            本次共搜索到沙龙预约次数:${res.booking_num}次 <br>
            ${res.depts.map((item) => `${item.dept_name}:${item.count}次 `)}
          `;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.reserve {
  height: 100%;
  overflow: hidden;
  // overflow: scroll;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .el-button {
    width: 100%;
    background-color: #e7635e;
    border: none;
  }
  .reserve-title {
    margin-bottom: 10px;
    color: #e7635e;
    min-height: 40px;
  }
  .reserve-table {
    flex: 1;
    overflow: hidden;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
  .el-date-editor.el-input__inner {
    width: 220px;
  }
  .reserve-table-mobile {
    flex: 1;
    overflow: scroll;
  }
  .van-cell {
    align-items: center;
  }
  .reserve-table-mobile-item-title-name {
    font-size: 15px;
    font-weight: 600;
  }
  .reserve-table-mobile-item-title {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    align-items: center;
    .reserve-table-mobile-item-title-right {
      text-align: right;
      flex-shrink: 0;
      font-size: 15px;
    }
  }
  .reserve-table-mobile-item-content-infor {
    display: flex;
    padding: 3px 0;
    .reserve-table-mobile-item-content-lable {
      width: 60px;
      flex-shrink: 0;
      color: #999;
    }
    .reserve-table-mobile-item-content-text {
      text-align: left;
      color: #000;
    }
  }
  // .van-cell::after {
  //   display: none;
  // }
  .van-collapse-item--border::after {
    border-top: 4px solid #eee;
    left: 0;
    right: 0;
  }
  .van-collapse-item__content {
    // padding-top: 0;
    font-size: 12px;
  }
}
.reserve-export {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  .el-button {
    width: 100px;
  }
}
</style>